import { bearerToken } from '../../constants/variables/local-storage.constant';

export const removeAuthorisationToken = () => {
  localStorage.removeItem(bearerToken);
};
